import { render, staticRenderFns } from "./EditObject.vue?vue&type=template&id=3572b0e2&scoped=true"
import script from "./EditObject.vue?vue&type=script&lang=js"
export * from "./EditObject.vue?vue&type=script&lang=js"
import style0 from "./EditObject.vue?vue&type=style&index=0&id=3572b0e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3572b0e2",
  null
  
)

export default component.exports